// Copyright © 2024 650 Industries.

'use client';

import React from 'react';
import { View } from 'react-native';

import { GlassContainerProps } from './GlassContainer.types';

export default function GlassContainer(props: GlassContainerProps) {
  return <View {...props} />;
}
